import { Component, OnInit } from "@angular/core";
import {
  faPencil,
  faTrash,
  faBroom,
  faPrint,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CarAllocationService } from "src/app/services/autopac/car-allocation.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-car-allocation",
  templateUrl: "./car-allocation.component.html",
  styleUrls: ["./car-allocation.component.css"],
})
export class CarAllocationComponent implements OnInit {
  faPencil = faPencil;
  faPrint = faPrint;
  faTrash = faTrash;
  faBroom = faBroom;
  faSave = faSave;

  isAllocationConfirmed = false;
  selectedTab = "single";
  isDropAllowed = false;

  searchVehicles!: FormField[];
  detailsVehicle: FormField[] = [
    {
      type: "search",
      id: "CaseNumber",
      label: "VIN Number",
      searchEvent: true,
      searchType: "vinSearch",
    },
    {
      type: "text",
      id: "ColourCode",
      label: "Colour",
      lock: true,
    },
    {
      type: "text",
      id: "ModelCode",
      label: "Model",
      lock: true,
    },
    {
      type: "text",
      id: "IntColourCode",
      label: "Interior colour",
      lock: true,
    },
  ];

  detailsContract: FormField[] = [
    {
      type: "search",
      id: "ContractNo",
      label: "Contract number",
      searchEvent: true,
      searchType: "contractSearch",
    },
    {
      type: "text",
      id: "ContractDate",
      label: "Contract date",
    },
    {
      type: "text",
      id: "BuyerNric",
      label: "Buyer's NRIC",
    },
    {
      type: "text",
      id: "BuyerName",
      label: "Buyer's name",
    },
    {
      type: "text",
      id: "BuyerContact",
      label: "Buyer's contact",
    },
    {
      type: "text",
      id: "BuyerAddress",
      label: "Buyer's address",
    },
    {
      type: "select",
      id: "SalesConsultant",
      label: "Sales consultant",
    },
    {
      type: "text",
      id: "FinanceCompany",
      label: "Finance company",
    },
    {
      type: "date",
      id: "TakenDate",
      label: "COE actual taken date",
    },
    {
      type: "textarea",
      id: "Remarks",
      label: "Order remarks",
    },
  ];

  allocatedList: any[] = [];
  notAllocatedList: any[] = [];
  salesConsultantList: any[] = [];

  tableSingleAllocation__headers = [
    { title: "VIN NUMBER", type: "data", id: "CaseNumber" },
    { title: "MODEL", type: "data", id: "ModelCode" },
    { title: "COLOUR", type: "data", id: "ColourCode" },
    { title: "INT COLOUR", type: "data", id: "IntColourCode" },
    { title: "ETA DATE", type: "data", id: "EtaDate" },
    { title: "CONTRACT NUMBER", type: "data", id: "ContractNumber" },
    { title: "", type: "link", id: "link", classes: "underline" },
  ];

  tableSingleAllocation__entries: any[] = [];

  tableAllAllocation__headers = [
    { title: "CONTRACT DATE", type: "data", id: "ContractDate" },
    { title: "CONTRACT NUMBER", type: "data", id: "ContractNo" },
    { title: "BUYER'S NAME", type: "data", id: "BuyerName" },
    { title: "MODEL", type: "data", id: "ModelCode" },
    { title: "COLOUR", type: "data", id: "ColourCode" },
    {
      title: "EXCLUDE FROM ALLOCATION",
      type: "checkbox",
      id: "Excluded",
      Hclasses: "text-center",
    },
  ];

  tableAllAllocation__entries: any[] = [];

  tableAllAllocation__headersWithoutCheckbox = [
    { title: "CONTRACT DATE", type: "data", id: "contractDate" },
    { title: "CONTRACT NUMBER", type: "data", id: "contractNumber" },
    { title: "BUYER'S NAME", type: "data", id: "buyersName" },
    { title: "MODEL", type: "data", id: "model" },
    { title: "COLOUR", type: "data", id: "colour" },
    { title: "VIN NUMBER", type: "data", id: "vinNumber" },
  ];

  constructor(
    private carAllocationService: CarAllocationService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.fetchInitialData();
    this.loadVehicleList();
    this.loadColourList();
    this.loadInteriorColourList();

    this.searchVehicles = [
      {
        type: "select",
        id: "searchVehicles__model",
        label: "Model",
        value: "All",
      },
      {
        type: "select",
        id: "searchVehicles__colour",
        label: "Colour",
        value: "All",
      },
      {
        type: "select",
        id: "searchVehicles__interiorColour",
        label: "Interior colour",
        value: "All",
      },
    ];
  }

  fetchInitialData(): void {
    this.carAllocationService
      .getModelActiveInSalesDrpList()
      .subscribe(
        (response) => {
          this.getField("searchVehicles__model").options = [
            { value: "All", display: "All" },
            ...response.body.map((item: any) => ({
              value: item.Name,
              display: item.Name,
            })),
          ];
        },
        (error) => {
          console.error("Error fetching active models:", error);
        },
      );

    this.carAllocationService.getAllActiveUsers().subscribe(
      (response) => {
        if (Array.isArray(response?.body)) {
          this.salesConsultantList = response.body;

          this.getField("SalesConsultant").options =
            response.body.map((item: any) => ({
              display: item.display_name,
              value: item.user_id,
            }));
        }
      },
      (error) => {
        console.error("Error fetching active users:", error);
      },
    );

    this.carAllocationService.getSecuredCoeList().subscribe(
      (response) => {
        this.tableAllAllocation__entries = response.body;
      },
      (error) => {
        console.error("Error fetching SecuredCoeList:", error);
      },
    );
  }

  updateFields(event: {
    fields: any[];
    name: string;
    updatedValue: number;
  }): void {
    const FIELD_CHANGED = { MODEL: 0, COLOUR: 2 } as const;

    if (
      event.name === "detailsContract" &&
      event.updatedValue === 0
    ) {
      this.isDropAllowed = Boolean(this.getField("ContractNo").value);
      return;
    }

    if (event.name !== "searchVehicles") {
      return;
    }

    const selectedModel = this.getFormattedValue(
      "searchVehicles__model",
    );
    const selectedColour = this.getFormattedValue(
      "searchVehicles__colour",
    );
    const selectedIntColour = this.getFormattedValue(
      "searchVehicles__interiorColour",
    );

    if (event.updatedValue === FIELD_CHANGED.MODEL) {
      this.loadColourList(selectedModel);
      this.loadInteriorColourList(selectedModel, selectedColour);
    }

    this.loadVehicleList(
      selectedModel,
      selectedColour,
      selectedIntColour,
    );
  }

  loadVehicleList(
    model: string = "%22All%22",
    colour: string = "%22All%22",
    intColour: string = "%22All%22",
  ): void {
    this.carAllocationService
      .getVehicleList(colour, intColour, model)
      .subscribe(
        (response) => {
          this.tableSingleAllocation__entries = response.body.map(
            (vehicle: any) => ({ ...vehicle, link: "select" }),
          );
        },
        (error) => {
          console.error("Error fetching vehicle list:", error);
        },
      );
  }

  loadColourList(model: string = "%22All%22"): void {
    this.carAllocationService.getColourList(model).subscribe(
      (response) => {
        if (Array.isArray(response?.body)) {
          this.populateDropdown(
            response.body,
            "searchVehicles__colour",
          );
        }
      },
      (error) => {
        console.error("Error fetching colour list:", error);
      },
    );
  }

  loadInteriorColourList(
    model: string = "%22All%22",
    colour: string = "%22All%22",
  ): void {
    this.carAllocationService
      .getIntColourCode(model, colour)
      .subscribe(
        (response) => {
          if (Array.isArray(response?.body)) {
            this.populateDropdown(
              response.body,
              "searchVehicles__interiorColour",
            );
          }
        },
        (error) => {
          console.error(
            "Error fetching interior colour list:",
            error,
          );
        },
      );
  }

  openEntry(entry: any): void {
    this.carAllocationService
      .getVehicleDetails(entry.CaseNumber)
      .subscribe(
        (response) => {
          if (response && response.body) {
            for (const [key, value] of Object.entries(
              response.body,
            )) {
              this.getField(key).value = value;
            }
          } else {
            console.warn("No data found for the given VIN number");
          }
        },
        (error) => {
          console.error("Error fetching vehicle details:", error);
        },
      );
  }

  search(event: any): void {
    const searchValue = this.getField(event.fieldId).value;

    if (!searchValue) {
      this.notifier.notify("error", "Please enter a valid value");
      return;
    }

    const request$ =
      event.fieldId === "CaseNumber"
        ? this.carAllocationService.getVehicleDetails(searchValue)
        : this.carAllocationService.getContractDetails(searchValue);

    request$.subscribe(
      (response) => {
        if (response.body.Code === -2) {
          this.notifier.notify("error", response.body.Message);
          return;
        }
        for (const [key, value] of Object.entries(response.body)) {
          if (key === "TakenDate" && typeof value === "string") {
            this.getField(key).value =
              this.convertDateToYYYYMMDD(value);
          } else {
            this.getField(key).value = value;
          }
        }
      },
      (error) => {
        console.error("Error fetching details:", error);
      },
    );
  }

  singleAllocation(): void {
    const fields = [
      "CaseNumber",
      "ColourCode",
      "ModelCode",
      "IntColourCode",
      "ContractNo",
      "ContractDate",
      "FinanceCompany",
      "Remarks",
      "BuyerContact",
      "BuyerName",
      "BuyerNric",
      "BuyerAddress",
      "SalesConsultant",
    ];

    const model = Object.fromEntries(
      fields.map((field) => [field, this.getField(field).value]),
    );

    model["TakenDate"] = this.convertDateToDDMMYYYY(
      this.getField("TakenDate").value,
    );

    this.carAllocationService.allocate(model).subscribe(
      (response) => {
        this.notifier.notify(
          response.body.Code === -1 ? "error" : "success",
          response.body.Message,
        );
      },
      (error) => {
        console.error("Error during allocation:", error);
      },
    );
  }

  dropAllocation(): void {
    const contractNo = this.getField("ContractNo").value;

    this.carAllocationService.dropAllocation(contractNo).subscribe(
      (response) => {
        if (response?.body?.Message) {
          this.notifier.notify("warning", response.body.Message);
        }
      },
      (error) => {
        console.error("Error during drop allocation:", error);
      },
    );
  }

  allocateAll(): void {
    this.isAllocationConfirmed = true;

    const contractNoList = this.tableAllAllocation__entries.map(
      (entry) => entry.ContractNo,
    );

    this.carAllocationService.allocateAll(contractNoList).subscribe(
      () => {},
      (error) => {
        console.error(error);
      },
    );
  }

  clearDataForms(): void {
    this.detailsVehicle.forEach((field) => (field.value = undefined));
    this.detailsContract.forEach(
      (field) => (field.value = undefined),
    );
  }

  /* UTILITY FUNCTIONS */

  convertDateToYYYYMMDD(dateString: string): string {
    if (!dateString) return "";

    const parts = dateString.split("/");
    if (parts.length !== 3) return dateString;

    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  }

  convertDateToDDMMYYYY(dateString: string): string | null {
    if (!dateString) return null;

    const parts = dateString.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    return dateString;
  }

  populateDropdown(data: any[], fieldId: string): void {
    this.getField(fieldId).options = [
      { value: "All", display: "All" },
      ...data.map((item) => ({
        value: item.Value || "",
        display: item.Name || "",
      })),
    ];
  }

  getFormattedValue(fieldId: string): string {
    const selectedValue = this.getField(fieldId).value || "All";

    const encodedValue = encodeURIComponent(
      selectedValue.replace(/"/g, '\\"').replace(/\s/g, "+"),
    )
      .replace(/%2B/g, "+")
      .replace(/%25/g, "");

    return `"${encodedValue}"`;
  }

  getField(id: string): FormField {
    const allFields: FormField[] = [
      ...this.detailsContract,
      ...this.detailsVehicle,
      ...this.searchVehicles,
    ];
    return (
      allFields.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
